import { stringSearch } from '@luminovo/design-system';
import { createFileRoute, redirect } from '@tanstack/react-router';

import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/projects/$projectId/bom/assembly/add-assembly')({
    // Only redirects: the new page checks its own access.
    staticData: { access: 'authenticated', chrome: 'none' } satisfies PageStaticData,
    validateSearch: stringSearch({ assemblyId: 'required' }),
    // The parent assembly moved from `?assemblyId=` into the path of `$assemblyId/subassemblies/create`.
    beforeLoad: ({ params, search }) => {
        throw redirect({
            to: '/projects/$projectId/bom/assembly/$assemblyId/subassemblies/create',
            params: { projectId: params.projectId, assemblyId: search.assemblyId },
            replace: true,
        });
    },
});
